export const FETCH_RADIUS_METRES = 500

export const METRES_PER_LAT_DEG = 111_320
